var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFrame6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#FFAC30",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 25.5L12.375 24.375L13.5 25.5L14.625 24.375L15.75 25.5L16.935 24.315C17.04 24.4575 17.16 24.585 17.2875 24.7125C18.2714 25.6817 19.5976 26.2243 20.9788 26.2226C22.3599 26.2209 23.6848 25.675 24.6663 24.7034C25.6479 23.7317 26.207 22.4124 26.2227 21.0314C26.2384 19.6503 25.7093 18.3187 24.75 17.325V10.5L23.625 11.625L22.5 10.5L21.375 11.625L20.25 10.5L19.125 11.625L18 10.5L16.875 11.625L15.75 10.5L14.625 11.625L13.5 10.5L12.375 11.625L11.25 10.5V25.5ZM24.6375 21C24.6375 21.48 24.5475 21.9525 24.375 22.395C24.18 22.83 23.91 23.25 23.5725 23.5725C23.25 23.91 22.83 24.18 22.395 24.375C21.9525 24.5475 21.48 24.6375 21 24.6375C18.99 24.6375 17.3625 23.01 17.3625 21C17.3625 20.0325 17.745 19.125 18.4275 18.4275C19.125 17.745 20.0325 17.3625 21 17.3625C23.0025 17.3625 24.6375 18.99 24.6375 21ZM20.25 21.5175V18.75H21.375V20.865L23.205 21.9225L22.6425 22.8975L20.25 21.5175Z",
    fill: "#FFAC30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFrame6);
export default __webpack_public_path__ + "static/media/stats_frame_6.f5b2df889bfac445164e12ae8281af98.svg";
export { ForwardRef as ReactComponent };